import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=3d9b757e&scoped=true"
import script from "./rank.vue?vue&type=script&lang=ts"
export * from "./rank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b757e",
  null
  
)

export default component.exports